import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

const examinee = 'examinee';
const project = 'project';

const apiRoutes = {
	examinee: examinee,
	checkPerson: examinee + '/check-person-id-exist',
	questionnaires: project + '/list/questionnaires',
}

@Injectable({ providedIn: 'root' })
export class ExamineeService {

	private refreshQuestionnaireList = new Subject<void>();

	constructor(private http: HttpClient) { }

	refreshList() {
    this.refreshQuestionnaireList.next();
  }

	getRefreshObservable() {
    return this.refreshQuestionnaireList.asObservable();
  }

	getProjectQuestionnairesList(project_id: number, params: any) {
		return this.http.get<any>(environment.api + apiRoutes.questionnaires + '/' + project_id, { params: params });
	}

	checkPersonIDExists(project_id: number, params: any) {
		return this.http.get<any>(environment.api + apiRoutes.checkPerson + '/' + project_id, { params: params });
	}

	getProjectExaminees(project_id: number, params: any) {
		return this.http.get<any>(environment.api + apiRoutes.examinee + '/' + project_id, { params: params });
	}

	getExaminees(params: any) {
		return this.http.get<any>(environment.api + apiRoutes.examinee + '/all', { params: params });
	}

	getExamineeDetails(project_id: number, examinee_id:number) {
		return this.http.get<any>(environment.api + apiRoutes.examinee + '/details/' + project_id + '/' + examinee_id);
	}

	getProjectQuestionnaireExaminees(project_id: number, questionnaire_id: number, params: any) {
		return this.http.get<any>(environment.api + apiRoutes.examinee + '/' + project_id + '/' + questionnaire_id, { params: params });
	}

	inviteProjectExaminee(project_id: number, questionnaire_id: number, data: any) {
		return this.http.post<any>(environment.api + apiRoutes.examinee + '/' + project_id + '/' + questionnaire_id, data);
	}

	resendInviteProjectExaminee(project_id: number, examinee_id: number, data: any) {
		return this.http.patch<any>(environment.api + apiRoutes.examinee + '/' + project_id + '/' + examinee_id, data);
	}

	deleteExaminee(examinee_id: number) {
		return this.http.delete<any>(environment.api + apiRoutes.examinee + '/' + examinee_id);
	}
}